export function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export const shortenedText = (
  text,
  includedChars = 5,
  threshold = 10,
  end = false
) => {
  if (text?.length > threshold) {
    if (end) {
      return `${text.slice(0, includedChars)}...`;
    }
    return `${text.slice(0, includedChars)}...${text.slice(-includedChars)}`;
  }
  return text;
};

export const hexToString = (hex) => {
  try {
    const data = decodeURIComponent(
      hex.replace(/\s+/g, '').replace(/[0-9a-f]{2}/g, '%$&')
    );

    return data.startsWith('0x') ? data.slice(2) : data;
  } catch (e) {
    var s = hex.toString();
    var str = '';
    for (var i = 0; i < s.length; i += 2)
      str += String.fromCharCode(parseInt(s.substr(i, 2), 16));
    return str;
  }
};

